import { GalaxyApi } from "@/api";
import { purgeDataset, undeleteDataset } from "@/api/datasets";
import { rethrowSimple } from "@/utils/simple-error";
const itemSizeSummaryFields = "id,name,size,deleted,archived";
export async function fetchAllHistoriesSizeSummary() {
    const { data: nonPurgedHistories, error: nonPurgedHistoriesError } = await GalaxyApi().GET("/api/histories", {
        params: {
            query: {
                keys: itemSizeSummaryFields,
                q: ["deleted", "purged"],
                qv: ["None", "false"],
            },
        },
    });
    if (nonPurgedHistoriesError) {
        rethrowSimple(nonPurgedHistoriesError);
    }
    const { data: nonPurgedArchivedHistories, error: nonPurgedArchivedHistoriesError } = await GalaxyApi().GET("/api/histories/archived", {
        params: {
            query: {
                keys: itemSizeSummaryFields,
                q: ["purged"],
                qv: ["false"],
            },
        },
    });
    if (nonPurgedArchivedHistoriesError) {
        rethrowSimple(nonPurgedArchivedHistoriesError);
    }
    const allHistoriesTakingStorageResponse = [
        ...nonPurgedHistories,
        ...nonPurgedArchivedHistories,
    ];
    return allHistoriesTakingStorageResponse;
}
export async function fetchHistoryContentsSizeSummary(historyId, limit = 5000, objectStoreId = null) {
    const q = ["purged", "history_content_type"];
    const qv = ["false", "dataset"];
    if (objectStoreId) {
        q.push("object_store_id");
        qv.push(objectStoreId);
    }
    const { data, error } = await GalaxyApi().GET("/api/datasets", {
        params: {
            query: {
                history_id: historyId,
                keys: itemSizeSummaryFields,
                limit,
                order: "size-dsc",
                q: q,
                qv: qv,
            },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function fetchObjectStoreContentsSizeSummary(objectStoreId, limit = 5000) {
    const { data, error } = await GalaxyApi().GET("/api/datasets", {
        params: {
            query: {
                keys: itemSizeSummaryFields,
                limit,
                order: "size-dsc",
                q: ["purged", "history_content_type", "object_store_id"],
                qv: ["false", "dataset", objectStoreId],
            },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function undeleteHistoryById(historyId) {
    const { data, error } = await GalaxyApi().POST("/api/histories/deleted/{history_id}/undelete", {
        params: {
            path: { history_id: historyId },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function purgeHistoryById(historyId) {
    const { data, error } = await GalaxyApi().DELETE("/api/histories/{history_id}", {
        params: {
            path: { history_id: historyId },
            query: { purge: true },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function undeleteDatasetById(datasetId) {
    const data = await undeleteDataset(datasetId);
    return data;
}
export async function purgeDatasetById(datasetId) {
    const data = await purgeDataset(datasetId);
    return data;
}
